export default "__VITE_ASSET__B6P2gQ9p__"